import emoji from "emoji-dictionary"
import { fs } from "../controls/Constants"
import CodeFormatter from "../components/CodeFormatter"
import CodeArticle from "../components/CodeArticle"

const KariInfrared = () => {
    const usage = 
    `irSensor->onMeasure(
        [] () {
            Serial.println("Infrared signal detected!");
        }
    );
    `
    const codeSnippet = 
    `#include <kari.h>

using namespace kari;

int pin = 5;
kariInfrared *irSensor;

void onDetection() {
    Serial.println("Infrared signal detected!");
}

void setup() {
    Serial.begin(9600);
    kariBegin({pin});
    irSensor = new kariInfrared(pin); // Initialize infrared sensor on pin 5
}

void loop() {
    kariAsync::execute(
    [] () {
        irSensor->onMeasure(onDetection); // Check for infrared signal continuously
    },
    100
    );
}

    `
    const introduction =
    `The kariInfrared class provides a simple interface for working with infrared (IR) sensors in the Kari IoT Library. 
    It allows users to detect infrared signals and execute callbacks when a measurement is taken.
    `
    return (
    <>
    <section>
        <h1>{emoji.getUnicode("satellite")} kariInfrared</h1>
        <h2>Introduction</h2>
        <p className={`text-formatter ${fs}`}>{introduction}</p>
    </section>
    <section>
        <h2>{emoji.getUnicode("wrench")} Key Features</h2>
        <ul className={`${fs}`}>
            <li><strong>Signal Detection</strong> - Detects infrared signals from sensors.</li>
            <li><strong>Callback Functionality</strong> - Executes a user-defined function when a signal is detected.</li>
            <li><strong>Easy Pin Configuration</strong> - Uses a single pin for operation.</li>
            <li><strong>Property Access Support</strong> - Can retrieve internal properties using getProperty().</li>
        </ul>
    </section>
    <h2>{emoji.getUnicode("hammer_and_wrench")} API Reference</h2>
    <CodeFormatter codeSnippet={
        `kariInfrared(int &signal);\nvoid onMeasure(void(*callback)());`
    } />
    <section>
        <h2>{emoji.getUnicode("memo")} Class Methods</h2>
        <CodeArticle
        intro="Constructor"
        index="one"
        other={null}
        codeSignature={`kariInfrared(int &signal);`}
        codeUsage={`int pin = 7;\nkariInfrared irSensor(pin);  // IR sensor connected to pin 5`}
        data={[
            "Initializes an infrared sensor object using the provided signal pin."
        ]}
        />
        <p className={`${fs}`}>{`${emoji.getUnicode("warning")} kariInfrared only takes in lvalues thats is kariInfrared(5) would lead to an error
        hence the pin must be stored in a variable as shown in the basic usage example below.
        `}</p>
        <CodeArticle
        intro="Detection of signals"
        index="two"
        codeSignature={`void onMeasure(void(*callback)());`}
        codeUsage={usage}
        other={null}
        data={[
            "Registers a callback function that executes whenever the infrared sensor detects a signal"
        ]}
        />
    </section>
    <h2>{emoji.getUnicode("hammer")} Basic Usage Example</h2>
    <CodeFormatter codeSnippet={codeSnippet}/>        
    </>
    )
}

export default KariInfrared
